<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMTeamList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMTeamForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMTeamForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMTeamForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmteam/update/isLoading',
      error: 'excmteam/update/error',
      deleteError: 'excmteam/del/error',
      deleteLoading: 'excmteam/del/isLoading',
      created: 'excmteam/create/created',
      deleted: 'excmteam/del/deleted',
      retrieved: 'excmteam/update/retrieved',
      updated: 'excmteam/update/updated',
      violations: 'excmteam/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMTeamList' })
    },
    updated: function () {
      this.$router.push({ name: 'EXCMTeamShow', params: { id: this.updated['@id'] } })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmteam/create/reset',
      deleteItem: 'excmteam/del/del',
      delReset: 'excmteam/del/reset',
      retrieve: 'excmteam/update/retrieve',
      updateReset: 'excmteam/update/reset',
      update: 'excmteam/update/update',
      updateRetrieved: 'excmteam/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmteam ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.teamUserData) {
        delete this.retrieved.teamUserData
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
